import React from "react";

import { Alert, Spin } from "antd";

import {
  CreditScoreSummary,
  CriminalRecordsType,
  EvictionsType,
} from "../interfaces";
import {
  getPendingReportTypes,
  getPendingReportMessage,
} from "../utils/reportStatusHelpers";

interface PendingReportsBannerProps {
  creditScoreSummary?: CreditScoreSummary;
  criminalRecords?: CriminalRecordsType;
  evictions?: EvictionsType;
}

const PendingReportsBanner: React.FC<PendingReportsBannerProps> = ({
  creditScoreSummary,
  criminalRecords,
  evictions
}) => {
  const pendingTypes = getPendingReportTypes(
    creditScoreSummary,
    criminalRecords,
    evictions
  );

  if (pendingTypes.length === 0) {
    return null;
  }

  const getBannerMessage = () => {
    if (pendingTypes.length === 1) {
      return getPendingReportMessage(
        pendingTypes[0] as "credit" | "criminal" | "eviction"
      );
    }

    if (pendingTypes.length === 2) {
      return `${pendingTypes[0]} and ${pendingTypes[1]} reports are being processed`;
    }

    return "Background reports are being processed";
  };

  return (
    <Alert
      style={{ marginBottom: "16px" }}
      type="info"
      showIcon
      icon={<Spin size="small" />}
      message={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {getBannerMessage()}
        </div>
      }
      description="Reports will be updated when processing is complete."
    />
  );
};

export default PendingReportsBanner;
